import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import 'sweetalert2/dist/sweetalert2.min.css'
import LightBootstrap from './light-bootstrap-main'
// Plugins
import App from './App.vue'
import lib from './lib.js'
import store from './store/index'
import Axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';

// router setup
import routes from './routes/routes'
// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(Vuex)
Vue.use(VueSweetalert2)

if (sessionStorage.getItem('user')) {
  store.commit('set_user', sessionStorage.getItem('user'))
}
// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

Axios.defaults.headers.common['authorization'] = (lib.getUser() !== null) ? 'Bearer ' + lib.getUser().token : null


//check auth
router.beforeEach((to, from, next) => {
  if (to.name !== 'Login' && lib.getUser() === null) next('/login')
  else next()
})

Axios.interceptors.request.use(config => {
  if (lib.getUser() !== null) {
    config.headers.common['authorization'] = 'Bearer ' + lib.getUser().token
  }
  return config
}, error => {
  return Promise.reject(error)
})

Axios.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        store.commit('del_user')
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath }
        })
    }
    return Promise.reject(error.response)
  }
})

const enableLog = true
const originalLog = console.log
console.log = function () {
  if (enableLog) {
    originalLog(...arguments)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})

